<template>
  <div class="">
    <Card class="">
      <template #title> Yetki Yerleri </template>
      <template #content>
        <div class="mt-1 mb-2 mr-3">
          <Button icon="pi pi-plus " size="small" label="Yeni" @click="_YeniYetkiYeri()" />
        </div>
        <DataTable v-if="DataTable_render" :columns="columns" :data="YetkiYerleriListesi" :editbutton="true"
          v-on:set-child-data="getDataChild" />
      </template>
    </Card>

    <Dialog v-model:visible="YetkiYeriModal" :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
      :style="{ width: '35vw' }" :modal="true">
      <template #header>
        <h4>Yeni Yetki Yeri</h4>
      </template>

      <div class="grid fluid formgrid">
        <div class="field col-6">
          <label for="YerAdi" class="font-bold block">Yer Adı</label>
          <InputText id="YerAdi" type="text" v-model="YerAdi" class="text-base text-color w-full" />
        </div>
        <div class="field col-6">
          <label for="YetkiTanim" class="font-bold block">Yer Tanımı</label>
          <InputText id="YetkiTanim" type="text" v-model="YetkiTanim" class="text-base text-color w-full" />
        </div>
        <div class="field col-6">
        </div>
        <div class="field col-6">

          <label for="Icon" class="font-bold block">Icon</label>
          <Select v-model="SelectedIcon" :options="IconListesi" optionLabel="IconAd" optionValue="Icon_rowid"
            placeholder="İkon Seçin" checkmark :highlightOnSelect="true" class="w-full md:w-56" filter>
            <template #value="slotProps">
              <div v-if="slotProps.value" class="flex items-center">
                <div>
                  <i :class="`pi ${slotProps.value.IconAd} `"></i>
                  {{ slotProps.value.IconAd }}
                </div>
              </div>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>
            <template #option="slotProps">
              <div class="flex align-items-center">
                <div>
                  <i :class="`pi ${slotProps.option.IconAd}`"></i>
                  {{ slotProps.option.IconAd }}
                </div>
              </div>
            </template>
          </Select>

        </div>
        <div class="field col-6">
          <label for="Rol" class="font-bold block">Rol</label>
          <Select id="Rol" v-model="SelectedRol" :options="RolListesi" optionLabel="Ad" optionValue="Rol_rowid"
            placeholder="Rol Seçin" checkmark :highlightOnSelect="true" class="w-full md:w-56" filter />
        </div>
        <div class="field col-6">
          <label for="WebSayfa" class="font-bold block">Web Sayfa</label>
          <Select id="WebSayfa" v-model="SelectedWebSayfa" :options="WebSayfaListesi" optionLabel="Ad"
            optionValue="WebSayfa_rowid" placeholder="Sayfa Seçin" checkmark :highlightOnSelect="true"
            class="w-full md:w-56" filter />
        </div>
        <div class="field col-6">
          <label for="UstMenu" class="font-bold block">Üst Menü</label>
          <Select id="UstMenu" v-model="SelectedUstMenu" :options="UstMenuListesi" optionLabel="Ad"
            optionValue="UstMenu" placeholder="Üst Menü Seçin" checkmark :highlightOnSelect="true"
            class="w-full md:w-56" filter />
        </div>

        <div class="field col-6">
          <label for="Sira" class="font-bold block">Sıra</label>
          <InputNumber id="Sira" v-model="Sira" inputId="horizontal-buttons" showButtons buttonLayout="horizontal"
            :step="1" decrementButtonClass="button-danger" incrementButtonClass="button-success"
            incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" :min="0" :max="999" fluid>
            <template #incrementbuttonicon>
              <span class="pi pi-plus" />
            </template>
            <template #decrementbuttonicon>
              <span class="pi pi-minus" />
            </template>
          </InputNumber>
        </div>
        <div class="field col-6">
          <div class="flex align-items-center">
            <Checkbox v-model="Separator" :binary="true" />
            <label for="ingredient1" class="ml-2"> Separator </label>
          </div>
        </div>
        <div class="field col-6">
          <div class="flex align-items-center">
            <Checkbox v-model="MenudeGoster" :binary="true" />
            <label for="ingredient2" class="ml-2"> Menüde Göster </label>
          </div>
        </div>
      </div>

      <Divider />
      <div class="flex justify-content-end flex-wrap">
        <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
          @click="this.handleClick()" autofocus />
        <Button class="m-1" label="Kapat" icon="pi pi-times" iconPos="right" size="small" severity="danger"
          @click="this._YetkiYeriModal()" />
      </div>
    </Dialog>
  </div>
</template>

<script>
// import { useVuelidate } from "@vuelidate/core";
import GlobalServis from "../../../../../services/GlobalServis";
import DataTable from "../../DataTable/BasicDataTable.vue";
// import { required, helpers } from "@vuelidate/validators";

export default {
  data() {
    return {
      PopUpDurumu: true, // True = Yeni , False = Edit
      DataTable_render: true,
      YetkiYeriModal: false,
      YetkiYerleriListesi: [],
      WebSayfaListesi: [],
      RolListesi: [],
      IconListesi: [],
      UstMenuListesi: [],
      columns: [
        {
          field: "YerAdi",
          header: "Yer Adı",
        },
        {
          field: "YetkiTanim",
          header: "Yetki Tanım",
        },
        {
          field: "Url",
          header: "URL",
        },
        {
          field: "RolAdi",
          header: "Rol",
        },
      ],
      YetkiYeri_rowid: null,
      YerAdi: "",
      YetkiTanim: "",
      SelectedRol: "",
      UstMenu: "",
      Sira: "",
      SelectedIcon: null,
      SelectedWebSayfa: "",
      Separator: false,
      MenudeGoster: true,
      SelectedUstMenu: "",
    };
  },
  methods: {
    InitServis() {
      this._GetRolListesi();
      this._GetIconListesi();
      this._GetUstMenu();
      this._GetWebSayfa()
    },
    _YetkiYeriModal() {
      this.YetkiYeriModal = !this.YetkiYeriModal;
      if (!this.YetkiYeriModal) {
        //this.resetForm();
      }
    },
    _YeniYetkiYeri() {
      this.ResetForm();
      this._YetkiYeriModal();
    },
    Refresh() {
      this.DataTable_render = false;
      this.$nextTick(() => {
        this.InitServis();
        this.DataTable_render = true;
      });
    },
    handleClick() {

      let data = {
        YetkiYeri_rowid: this.YetkiYeri_rowid,
        pRol: this.SelectedRol,
        Ad: this.YerAdi,
        Tanim: this.YetkiTanim,
        Separator: this.Separator,
        MenudeGoster: this.MenudeGoster,
        Sira: this.Sira,
        pIcon: this.SelectedIcon,
        UstMenu: this.SelectedUstMenu,
        WebSayfa_rowid: this.SelectedWebSayfa
      };
      if (this.PopUpDurumu) {
        // Yeni Yetki Yeri
        GlobalServis.GlobalServis("POST", "setYetkiYeri", data).then((res) => {
          if (res.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "Başarılı",
              detail: "Kullanıcı oluşturulmuştur",
              life: 3000,
            });
            this.Refresh();
            this._YetkiYeriModal();
          } else if (res.response.status === 999) {
            this.$toast.add({
              severity: "warn",
              summary: "Uyarı",
              detail: res.response.data,
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Hata oldu",
              life: 3000,
            });
          }
        }).then(() => {
        });

      } else {
        //Edit Yetki Yeri
        GlobalServis.GlobalServis("POST", "UpdateYetkiYeri", data).then((res) => {
          if (res.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "Başarılı",
              detail: "Yetki Yeri düzenlemiştir",
              life: 3000,
            });
            this.Refresh();
            this._YetkiYeriModal();
          } else if (res.response.status === 999) {
            this.$toast.add({
              severity: "warn",
              summary: "Uyarı",
              detail: res.response.data,
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Hata oldu",
              life: 3000,
            });
          }
        }).then(() => {
        });
      }

    },
    getDataChild(getdata_child) {
      this.ResetForm();
      this.PopUpDurumu = false;
      this.YetkiYeri_rowid = getdata_child.data.YetkiYeri_rowid;
      let data = {
        YetkiYeri_rowid: getdata_child.data.YetkiYeri_rowid,
      };
      GlobalServis.GlobalServis("POST", "GetYetkiYeriInfo", data)
        .then((res) => {
          if (res.status == 200) {
            this.YerAdi = res.data[0].YerAdi;
            this.YetkiTanim = res.data[0].YetkiTanim;
            this.SelectedRol = res.data[0].pRol;
            this.SelectedIcon = res.data[0].pIcon;
            this.SelectedWebSayfa = res.data[0].WebSayfa_rowid;
            // this.SelectedUstMenu = res.data[0].UstMenu;
            this.SelectedUstMenu = res.data[0].UstMenu;
            this.Sira = res.data[0].Sira;
            this.RolAciklama = res.data[0].RolAciklama;
          } else if (res.status == 400) {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Önemli bir hata meydana geldi",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Bilinmeyen bir hata meydana geldi",
              life: 3000,
            });
          }
        })
        .then(() => {
          this._YetkiYeriModal();
        });
    },
    _GetRolListesi() {
      GlobalServis.GlobalServis("GET", "GetRol", "")
        .then((res) => {
          if (res.status == 200) {
            this.RolListesi = res.data;
          } else if (res.status == 400) {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Önemli bir hata meydana geldi",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Bilinmeyen bir hata meydana geldi",
              life: 3000,
            });
          }
        })
        .finally(() => {
          this._GetYetkiYeriListesi();
        });
    },
    _GetYetkiYeriListesi() {
      GlobalServis.GlobalServis("GET", "GetYetkiYeri", "").then((res) => {
        if (res.status == 200) {
          this.YetkiYerleriListesi = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _GetIconListesi() {
      GlobalServis.GlobalServis("GET", "GetIconTablosu", "").then((res) => {
        if (res.status == 200) {
          this.IconListesi = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _GetUstMenu() {
      GlobalServis.GlobalServis("GET", "GetUstMenuTablosu", "").then((res) => {
        if (res.status == 200) {
          this.UstMenuListesi = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _GetWebSayfa() {
      GlobalServis.GlobalServis("GET", "GetWebSayfa", "").then((res) => {
        if (res.status == 200) {
          this.WebSayfaListesi = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    ResetForm() {
      this.YetkiYeri_rowid = null;
      this.YerAdi = "";
      this.YetkiTanim = "";
      this.SelectedRol = "";
      this.UstMenu = "";
      this.Sira = "";
      this.SelectedIcon = "";
      this.Separator = false;
      this.SelectedUstMenu = "";
      this.SelectedWebSayfa = "";
      this.PopUpDurumu = true;
    }
  },
  watch: {
    // eslint-disable-next-line
    RolID: function (val) {
      this._GetYetkiYeriListesi();
    },
  },
  mounted() {
    this.InitServis();
  },
  components: {
    DataTable,
  },
  // validations() {
  //   return {
  //     Sira: {
  //       required: helpers.withMessage("Bu alan boş bırakılamaz", required),
  //     },
  //     // SelectedUstMenu: {
  //     //     required: helpers.withMessage("Bu alan boş bırakılamaz", required),
  //     // },
  //     SelectedIcon: {
  //       required: helpers.withMessage("Bu alan boş bırakılamaz", required),
  //     },
  //     YerAdi: {
  //       required: helpers.withMessage("Bu alan boş bırakılamaz", required),
  //     },
  //     YetkiTanim: {
  //       required: helpers.withMessage("Bu alan boş bırakılamaz", required),
  //     },
  //     SelectedRol: {
  //       required: helpers.withMessage("Bu alan boş bırakılamaz", required),
  //     },
  //     SelectedWebSayfa: {
  //       required: helpers.withMessage("Bu alan boş bırakılamaz", required),
  //     },
  //   };
  // },
};
</script>

<style lang="scss" scoped></style>
